console.log("Script copy url");

function copierUrlPage() {
    const shareCopyBtn = document.querySelector('.share-copy');

    if (!shareCopyBtn) {
        console.warn('Share copy button (.share-copy) not found in the page.');
        return;
    }

    shareCopyBtn.addEventListener('click', (e) => {
        const btn = e.currentTarget;
        const labels = {
            title: btn.dataset.labelTitle,
            copy: btn.dataset.labelCopy,
            copied: btn.dataset.labelCopied,
            close: btn.dataset.labelClose,
        };
        const url = window.location.href;
        const backdrop = document.createElement('div');
        backdrop.className = 'share-modal-backdrop';
        const modal = document.createElement('div');
        modal.className = 'share-modal';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-labelledby', 'share-modal-title');
        modal.innerHTML = `
            <div class="share-modal__header">
                <h2 id="share-modal-title">${labels.title}</h2>
                <button type="button" class="share-modal__close btn btn-icon-only" aria-label="${labels.close}">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-cross"
                        aria-hidden="true">                    
                        <use href="../../static/icons/uga.svg#icon-cross"></use>
                    </svg>
                    <span class="visually-hidden">${labels.close}<span>
                </button>
            </div>
            <div class="share-modal__body">
                <p>
                <label for="share-modal-input" class="visually-hidden">${labels.title}</label>
                <input id="share-modal-input" type="text" value="${url}" readonly class="share-modal__input">
                </p>
                <button type="button" class="share-modal__copy btn-cta"><span>${labels.copy}<span></button>
            </div>
        `;
        backdrop.append(modal);
        document.body.append(backdrop);
        const copyBtn = modal.querySelector('.share-modal__copy');
        copyBtn.focus();
        copyBtn.addEventListener('click', () => {
            navigator.clipboard.writeText(url).then(() => {
                copyBtn.textContent = labels.copied;
            });
        });
        function fermer() {
            backdrop.remove();
            btn.focus();
            document.removeEventListener('keydown', ecouteurEchap);
        }
        modal.querySelector('.share-modal__close').addEventListener('click', fermer);
        backdrop.addEventListener('click', (e) => {
            if (e.target === backdrop) fermer();
        });
        function ecouteurEchap(e) {
            if (e.key === 'Escape') fermer();
        }
        document.addEventListener('keydown', ecouteurEchap);
        const focusableSelectors = 'button, input, [href], [tabindex]:not([tabindex="-1"])';
        modal.addEventListener('keydown', (e) => {
            if (e.key !== 'Tab') return;
            const focusable = [...modal.querySelectorAll(focusableSelectors)];
            const first = focusable[0];
            const last = focusable.at(-1);
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        });
    });
}

// execution ! partout sauf sur les pages d'accueil de langue
if (!document.body.classList.contains('is-homepage')) {
    copierUrlPage();
}